<nav class="breadcrumb">
  <a routerLink="/">Home</a>
  <span *ngIf="therapeuticArea"> - </span>
  <a
    [routerLink]="['/details', therapeuticArea, '']"
    routerLinkActive="active"
    *ngIf="therapeuticArea"
  >
    {{ therapeuticArea }}</a
  >
  <span *ngIf="elementName"> - </span>
  <a
    [routerLink]="['/details', therapeuticArea, elementName, '']"
    routerLinkActive="active"
    *ngIf="elementName"
  >
    {{ elementName | desanitize }}</a
  >
  <span *ngIf="activeFlag" class="active"> - {{ flagName }}</span>
  <span *ngIf="compare" class="active"> - Compare</span>
</nav>
